<template>
  <div class="base-register">
    <UiBtn
      class="base-register__button"
      color="primary"
      :text="$t('registration')"
      :to="to"
      :size="size"
      :size-small-mobile="sizeSmallMobile"
      @click="$emit('click')"
    />
  </div>
</template>
<script>

export default {
  name: 'BaseRegisterAnimation',
  props: {
    to: { type: String },
    size: { type: [String,Object], default: 'm' },
    sizeSmallMobile: { type: Boolean },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
